import { render, staticRenderFns } from "./EmptyStateCell.vue?vue&type=template&id=2cb1fe78&scoped=true&"
import script from "./EmptyStateCell.vue?vue&type=script&lang=js&"
export * from "./EmptyStateCell.vue?vue&type=script&lang=js&"
import style0 from "./EmptyStateCell.vue?vue&type=style&index=0&id=2cb1fe78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb1fe78",
  null
  
)

export default component.exports